import React from 'react';
import SVG from 'react-inlinesvg';
import { Fade } from 'react-reveal';
//Components
import { Select } from '../../components/Select';

//Imagens
import { images } from '../../settings';

import './MapaBrasil.scss';

class MapaBrasil extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      regiaoAtiva: 'mapa-brasil todas-regioes',
      mapaSelecionado: images.associados.MapaBrasilSvg2020,
      isMobile: '',
      ano: ''
    }
    this.scroll = React.createRef();
    this.bgMapa = {backgroundImage: `url("${images.associados.bgMapa}")`}
  }
  anoSelecionado = (e) => {
    this.setState({ ano: e })
    switch (e) {
      case '2020':
        this.setState({ mapaSelecionado: images.associados.MapaBrasilSvg2020 })
        break;
      case '2019':
        this.setState({ mapaSelecionado: images.associados.MapaBrasilSvg2019 })
        break;
      case '2018':
        this.setState({ mapaSelecionado: images.associados.MapaBrasilSvg2018 })
        break;
      case '2017':
        this.setState({ mapaSelecionado: images.associados.MapaBrasilSvg2017 })
        break;
      default:
        this.setState({ mapaSelecionado: images.associados.MapaBrasilSvg2019 })
    }
  }
  regiaoSelecionada = (lugar) => {
    this.setState({
      regiaoAtiva: `mapa-brasil ${lugar}`
    })
    if(window.innerWidth < 768) {
      this.scroll.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    }
  }
  LegendaMapa = () => {
    return(
      <div className={`mapa__botoes-regioes ${this.state.regiaoAtiva}`}>
        {/* <button className="mapa__botao-seleciona mapa__botao-seleciona--todas" onClick={ () => this.regiaoSelecionada('todas-regioes') } >
          Todos
        </button> */}
        <button className="mapa__botao-seleciona mapa__botao-seleciona--centro-oeste" onClick={ () => this.regiaoSelecionada('centro-oeste') } >
          Centro-Oeste
        </button>
        <button className="mapa__botao-seleciona mapa__botao-seleciona--nordeste" onClick={ () => this.regiaoSelecionada('nordeste') } >
          Nordeste
        </button>
        <button className="mapa__botao-seleciona mapa__botao-seleciona--norte" onClick={ () => this.regiaoSelecionada('norte') } >
          Norte
        </button>
        <button className="mapa__botao-seleciona mapa__botao-seleciona--sudeste" onClick={ () => this.regiaoSelecionada('sudeste') } >
          Sudeste
        </button>
        <button className="mapa__botao-seleciona mapa__botao-seleciona--sul" onClick={ () => this.regiaoSelecionada('sul') } >
          Sul
        </button>
        <button className="mapa__botao-seleciona mapa__botao-seleciona--exterior" onClick={ () => this.regiaoSelecionada('exterior') } >
          Exterior
        </button>
      </div>
    );
  }
  render = () => {
    const { ano } = this.state

    if (window.innerWidth < 768) {
      this.state.isMobile = true;
    } else {
      this.state.isMobile = false;
    }

    let total = 0;
    switch (ano) {
      case '2020':
        total = 265;
        break;
      case '2019':
        total = 265;
        break;
      case '2018':
        total = 260;
        break;
      case '2017':
        total = 267;
        break;
      default:
        total = 265;
    }

    return (
      // <div className="mapa" style={this.bgMapa}>
      <div className="mapa">
        <div className="mapa__content" ref={this.scroll}>
          <p className="mapa__texto">
          Essas instituições estão presentes em 14 estados brasileiros, nas cinco regiões do país, além de uma gestora internacional.
          </p>
          <div>
            <Select selecionaAno={this.anoSelecionado.bind(this)}/>
          </div>
          {!this.state.isMobile && <this.LegendaMapa /> }
        </div>
        <div className={this.state.regiaoAtiva}>
          <Fade right>
            <SVG src={this.state.mapaSelecionado} />
          </Fade>
        </div>
        
        <div className="mapa__total">{`Total ${total}`}</div>

        { this.state.isMobile && <this.LegendaMapa /> }
      </div>
    )
  }
}
export { MapaBrasil }